import api from './api';
import publicApi from './publicApi';

export const orderService = {
  createDeliveryOrder: async (order) => {
    const response = await publicApi.post('/orders/delivery', order);
    return response.data;
  },


  // ----- Actual Order Creation API -------------------
  createOrder: async (type, order) => {

    let endpoint = null;
    let response = null;
   

    if (sessionStorage.getItem('user')) {
      let user_data = JSON.parse(sessionStorage.getItem('user'));
      order["id"] = user_data["id"];
      endpoint = type === 'delivery' ? '/orders/user/delivery' : '/orders/user/takeaway';
      response = await api.post(endpoint, order);
      return response.data;
    }
    else {
      endpoint = type === 'delivery' ? '/orders/delivery' : '/orders/takeaway';
      response = await publicApi.post(endpoint, order);
      return response.data;
    }

  },

  createHitpayPayment: async (orderId) => {
    const response = await publicApi.post(`/orders/${orderId}/hitpay/create-payment`);
    return response.data;
  },

  createTableOrder: async (order) => {
    const response = await publicApi.post('/orders/table', order);
    return response.data;
  },

  createTableOrderPayment: async (orderId) => {
    const response = await publicApi.post(`/orders/${orderId}/hitpay/create-payment`);
    return response.data;
  },

  getAdminOrders: async (params = {}) => {
    const response = await api.get('/orders/',{params:params});
    return response.data;
  },

  getOrders: async () => {
    const response = await api.get('/orders/');
    return response.data;
  },

  approveOrder: async (orderId) => {
    const response = await api.patch(`/orders/${orderId}/approve`);
    return response.data;
  },

  rejectOrder: async (orderId, reason) => {
    const response = await api.patch(`/orders/${orderId}/reject`, { reason });
    return response.data;
  },

  getOrderById: async (orderId) => {
    const response = await publicApi.get(`/orders/${orderId}`);
    return response.data;
  },

  updateOrderStatus: async (orderId, status) => {
    const response = await api.patch(`/orders/${orderId}/status`, { status });
    return response.data;
  },

  sendOrderSMS: async (orderId) => {
    const response = await api.post(`/orders/${orderId}/send-sms`);
    return response.data;
  },

  getPaymentStatus: async (orderId) => {
    const response = await publicApi.get(`/orders/${orderId}/payment-status`);
    return response.data;
  },

  confirmPayment: async (orderId, paymentData) => {
    const response = await publicApi.post(`/orders/${orderId}/confirm-payment`, paymentData);
    return response.data;
  },

  orderDetail: async (unique_string) => {
    const response = await publicApi.get(`/orders/detail/${unique_string}`);
    return response.data;
  },

  updateDeliveryOrTakeawayTime: async (payload) => {
    try{
      const response = await api.put(`/orders/update_date_and_time/`,payload);
      return response.data;
    }
    catch(error){
      throw new Error(error)
    }
  }



};